import PropTypes from 'prop-types'

const Required = ({ hasAsterisk }) => (
  <If condition={hasAsterisk}>
    <span aria-hidden='true'>
      <abbr
        className='control-label__required'
        title='required'
      >
        {'* '}
      </abbr>
    </span>
  </If>
)

export default Required

Required.propTypes = { hasAsterisk: PropTypes.bool.isRequired }
